import type { SectionsConfig } from '@backoffice-frontend/authenticated-app-view'
import { isProduction } from '@backoffice-frontend/environment'
import { UserType } from '@backoffice-frontend/graphql'
import { PatternLibraryArea } from '@backoffice-frontend/pattern-library'
import { StatusArea } from '@backoffice-frontend/status'
import { UpdatesArea } from '@backoffice-frontend/updates'
import { UserManagementArea } from '@backoffice-frontend/user-management'
import { useBackofficeLoggedInUser } from '@backoffice-frontend/user-management-ui'
import { WelcomeAdminPanelArea } from '@backoffice-frontend/welcome-admin-panel'
import { useTranslation } from 'react-i18next'

export const useNavigationSections = (): SectionsConfig => {
  const { user } = useBackofficeLoggedInUser()
  const { t } = useTranslation()

  const isPlatformAdmin = user?.userType === UserType.PlatformAdmin

  const sectionConfig: SectionsConfig = [
    // Route-only areas (hidden from navigation bar)
    {
      areas: [WelcomeAdminPanelArea, UpdatesArea, StatusArea],
      hiddenInNavBar: true,
    },
    !isProduction()
      ? {
          label: t('adminPanelApp_testingSection_navigation'),
          areas: [PatternLibraryArea],
        }
      : null,
    {
      label: t('adminPanelApp_adminSection_navigation'),
      areas: [isPlatformAdmin ? UserManagementArea : null],
    },
  ]

  return sectionConfig
}
